export enum MessageType {
    ADD_FILE = 'ADD_FILE',
    NEW_FILE = 'NEW_FILE',
    UPLOAD = 'UPLOAD',
    DOWNLOAD = 'DOWNLOAD',
    DONE = 'DONE',
    MODE = 'MODE',
    PROPS = 'PROPS'
}

export enum Program {
    NEXO,
    FOBOS,
    DEIMOS
}

export enum Environment {
    DESKTOP,
    WEB
}

export enum ProgramMode {
    SCANNER,
    GRID
}

export enum AppSteps {
    NONE,
    DOWNLOAD,
    EDIT,
    UPLAOD,
    DONE,
    LOAD,
    NOLICENCE
}

export type NewMessageType<T extends string, D extends object> = {
    type: T;
    desc: D;
};

export interface ModeChangeMessage {
    mode: AppSteps;
}

export interface PropsMessage {
    program?: Program;
    environment?: Environment;
    programMode?: ProgramMode;
    showTutorial?: boolean;
}

export interface AddFileMessage {
    file: File;
    id: string;
    filename: string;
    fileSize: number;
    refId?: string | number;
}

export enum ProgressBarState {
    NEW,
    IN_PROGRESS,
    DONE,
    ERROR
}

export interface ProgressMessage {
    id: string;
    state: ProgressBarState;
    filename?: string;
    error?: string;
    progress?: number;
}

export interface SourcePageDetail {
    sourceFileRefId?: string | number;
    sourcePageNr: number;
}

export interface FileInfo {
    file: File;
    id: string;
    filename: string;
    deleted?: boolean;
    sourcePagesDetails: SourcePageDetail[];
}

export interface ResultFileMessage {
    files: FileInfo[];
    sessionId: string;
}

export type IMessage =
    | NewMessageType<MessageType.ADD_FILE, AddFileMessage>
    | NewMessageType<MessageType.UPLOAD, ProgressMessage>
    | NewMessageType<MessageType.DOWNLOAD, ProgressMessage>
    | NewMessageType<MessageType.MODE, ModeChangeMessage>
    | NewMessageType<MessageType.PROPS, PropsMessage>;

export type IResultMessage =
    | NewMessageType<MessageType.NEW_FILE, ResultFileMessage>
    | NewMessageType<MessageType.DONE, {}>;
